import { render } from "./dinamicDialog_lite.vue?vue&type=template&id=8f351732&scoped=true"
import script from "./dinamicDialog_lite.vue?vue&type=script&lang=js"
export * from "./dinamicDialog_lite.vue?vue&type=script&lang=js"

import "./dinamicDialog_lite.vue?vue&type=style&index=0&id=8f351732&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f351732"]])

export default __exports__